<style scoped lang="scss">
@import '../mobile';
</style>
<template>
  <div class="wrap-app">
    <qk-back/>
    <qk-status-icon :status="details.userWebOrderStatus" :statusName="statusName"/>
    <div class="basic">
      <div class="l-title">基本信息</div>
      <ul>
        <li>
          <label>订单号</label>
          <p>{{details.value.no}}</p>
        </li>
        <li>
          <label>下单时间</label>
          <p>{{details.value.createTime | rTime}}</p>
        </li>
        <li>
          <label>应付金额</label>
          <p class="text-danger">{{details.value.amount | amount}}元</p>
        </li>
        <li>
          <label>地址</label>
          <p>{{address}}</p>
        </li>
        <li v-show="details.value.remark !== ''">
          <label>备注</label>
          <p>{{details.value.remark}}</p>
        </li>
      </ul>
    </div>
    <div class="detail">
      <ul class="top-tab">
        <li :class="{active: currentTab === index}" v-for="(item, index) in detailsTabs" :key="index" @click="currentTab = index">{{item}}</li>
      </ul>
      <div class="tab-content">
        <div class="tab-panel" v-show="currentTab === 0">
          <table>
            <tr>
              <th>项目名称</th>
              <th>项目类型</th>
              <th>项目状态</th>
            </tr>
            <tr>
              <td>{{details.value.name}}</td>
              <td>{{details.value.type}}</td>
              <td>{{statusName}}</td>
            </tr>
          </table>
<!--          <div class="more">-->
<!--            <img src="@/assets/images/mobile/arrow_down.png">-->
<!--          </div>-->
        </div>
        <div class="tab-panel" v-show="currentTab === 1">
          <div class="molecular-lists">
            <div class="molecular-item send-info">
              <div class="top">
                <div class="info">
                  <img src="@/assets/images/mobile/icon_user.png" class="icon">
                  <div class="title">配送员/运单号：快递
<!--                    <div>快递</div>-->
<!--                    <div v-else>{{item.deliveryCode}}</div>-->
                  </div>
                  <p>配送单号：{{details.value.workOrderNo}}</p>
                </div>
<!--                <span class="status status-primary">{{item.sendStatusName}}</span>-->
              </div>
              <ul class="lists">
                <li>{{details.value.name}}<span>x{{details.value.num}}</span></li>
              </ul>
              <!--              <div class="more"><img src="@/assets/images/mobile/arrow_down.png"></div>-->
              <p class="text-gray9 mt10">签收时间：-</p>
            </div>
          </div>
<!--          <div class="no-data" v-show="sendLists.length === 0">暂无配送记录</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectDetail, sendOrders } from '@/services/api.index'
export default {
  data () {
    return {
      detailsTabs: ['项目信息', '配送信息'],
      currentTab: 0,
      id: this.$route.query.id,
      details: {},
      address: '',
      statusName: '',
      sendLists: []
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails () {
      projectDetail(this.id).then(res => {
        this.details = res.data
        const value = res.data.value
        this.statusName = this.baseMethods.orderStatus(res.data.userWebOrderStatus)
        this.address = value.raProvince ? `${value.raProvince}${value.raCity}${value.raCounty} ${value.raAddress}` : '-'
        this.getSendOrders()
      })
    },
    // 配送记录
    getSendOrders () {
      sendOrders(0, 10, this.details.value.no).then(res => {
        res.data.map(item => {
          item.sendStatusName = this.baseMethods.sendStatus(item.sendStatus)
        })
        this.sendLists = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/other/order_details.vue